module.exports = __webpack_public_path__ + "static/media/pt.55a651f8.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/pt.svg
// module id = 1335
// module chunks = 0